import { useMemo } from 'react'
import { CustomTable, TableEmptyState } from 'app/components'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { ExameList, ExameView } from '../core/_models'
import { getExameById } from '../core/_requests'
import { examesColumns } from './columns/_columns'
import { ExameExpandedRow } from './columns/ExameExpandedRow'
import { useT } from '_metronic/i18n/Metronici18n'

export const ExamesTable = () => {
  const { response, isLoading, isError, refetch } = useQueryResponse()
  const { filters, hasFilters, clearFilters } = useListFilters()
  const { t } = useT()
  const columns = useMemo(() => examesColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title={
        filters.nome.trim()
          ? `Nenhum exame encontrado para “${filters.nome.trim()}”`
          : 'Nenhum exame nesta situação'
      }
      description='Revise o nome digitado ou a situação selecionada.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhum exame cadastrado'
      description='Use “Adicionar” para cadastrar o primeiro exame.'
    />
  )

  return (
    <CustomTable<ExameList>
      id='kt_table_exames'
      ariaLabel={t('exame.plural')}
      itemLabel={{ singular: t('exame.label.lowercase'), plural: t('exame.plural.lowercase') }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
      // Descrição e cadastro vêm do endpoint do exame.
      enableExpand
      onExpandFetch={(row) => getExameById(row.original.id)}
      getExpandLabel={(row) => row.nome || `exame ${row.id}`}
      renderExpand={(data: ExameView, loading) => (
        <ExameExpandedRow data={data} isLoading={loading} />
      )}
    />
  )
}
